"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.analyticsHelperWebPayment = exports.analyticsHelperPayment = void 0;
var myaccount_frontend_shared_1 = require("@alinta-digital/myaccount-frontend-shared");
exports.analyticsHelperPayment = new myaccount_frontend_shared_1.AnalyticsHelper('process.payment');
exports.analyticsHelperWebPayment = new myaccount_frontend_shared_1.AnalyticsHelper('process.web.payment');
//# sourceMappingURL=analytics.js.map